import { render, staticRenderFns } from "./BuyerAccountUsageRecord.vue?vue&type=template&id=40ab2473&scoped=true"
import script from "./BuyerAccountUsageRecord.vue?vue&type=script&lang=js"
export * from "./BuyerAccountUsageRecord.vue?vue&type=script&lang=js"
import style0 from "./BuyerAccountUsageRecord.vue?vue&type=style&index=0&id=40ab2473&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ab2473",
  null
  
)

export default component.exports